import { render, staticRenderFns } from "./extendlist.vue?vue&type=template&id=fda9ca86&scoped=true"
import script from "./extendlist.vue?vue&type=script&lang=js"
export * from "./extendlist.vue?vue&type=script&lang=js"
import style0 from "./extendlist.vue?vue&type=style&index=0&id=fda9ca86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda9ca86",
  null
  
)

export default component.exports